var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 15.5355L16.9501 14.1213L18.3643 12.7071C20.3169 10.7545 20.3169 7.58866 18.3643 5.63604C16.4117 3.68341 13.2458 3.68341 11.2932 5.63604L9.87898 7.05025L8.46477 5.63604L9.87898 4.22182C12.6127 1.48815 17.0448 1.48815 19.7785 4.22182C22.5122 6.95549 22.5122 11.3876 19.7785 14.1213L18.3643 15.5355ZM15.5358 18.364L14.1216 19.7782C11.388 22.5118 6.9558 22.5118 4.22213 19.7782C1.48846 17.0445 1.48846 12.6123 4.22213 9.87868L5.63634 8.46446L7.05056 9.87868L5.63634 11.2929C3.68372 13.2455 3.68372 16.4113 5.63634 18.364C7.58896 20.3166 10.7548 20.3166 12.7074 18.364L14.1216 16.9497L15.5358 18.364ZM14.8287 7.75736L16.243 9.17157L9.17188 16.2426L7.75766 14.8284L14.8287 7.75736Z",
    fill: "#071E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.6282d456448a436a7f7c9c93953e8561.svg";
export { ForwardRef as ReactComponent };